<div
  class="app-modal-backdrop overflow-hidden"
  #backDropRef
  (click)="closeFromBackDrop($event)"
  tabindex="0"
  role="button"
  (keydown.enter)="closeFromBackDrop($event)"
  (keydown.space)="closeFromBackDrop($event)"
>
  <div
    class="
    modal
    app-modal
    d-flex
    flex-column
    bg-body-secondary
    shadow-lg
    mw-100
  "
    [ngClass]="cssClass"
    [ngStyle]="{
      transform: 'translateY(' + currentTranslateY + 'px)'
    }"
    [class.animate-back]="animateBack"
    [class.slide-down]="slideDown"
    (transitionend)="onTransitionEnd()"
  >
    <div
      class="modal-header flex-shrink-0"
      [ngClass]="headerClass"
    >
      @if (closable) {
        <button
          type="button"
          class="modal-close"
          aria-label="Close"
          (click)="close()"
          (touchstart)="onTouchStart($event)"
          (touchmove)="onTouchMove($event)"
          (touchend)="onTouchEnd()"
        >
          <i
            class="icon-x-close"
            aria-hidden="true"
          ></i>
        </button>
      }

      @if (titleTemplate) {
        <div class="modal-title">
          @if (isOpen) {
            <ng-container
              [ngTemplateOutlet]="titleTemplate"
            ></ng-container>
          }
        </div>
      }
    </div>

    <div
      class="
        modal-body
        flex-grow-1
        overflow-y-auto
        overflow-x-hidden
        w-100
        mw-100
      "
      [ngClass]="bodyClass"
    >
      @if (isOpen) {
        <ng-container
          [ngTemplateOutlet]="bodyTemplate"
        ></ng-container>
      }
    </div>
  </div>
</div>
